import styled from "@emotion/styled";
import Image from "next/image";
import { Link } from "../Link";

const Card = styled.div`
  display: flex;
  gap: 0 12px;
  border-radius: 16px;
  margin-top: 24px;
  padding: 20px;
  line-height: 1.5;
  color: #105246;
  background-color: #d0f4e0;

  a {
    color: inherit;
  }

  @media ${({ theme }) => theme.bp.mobileDown} {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const ImageWrapper = styled.div`
  flex-shrink: 0;
`;

export const ImpactFundDisclaimer = () => {
  return (
    <Card data-testid="tile-impact-fund-disclaimer">
      <ImageWrapper>
        <Image
          alt="Impact Fund Badge"
          width={56}
          height={56}
          src="/images/app/forest/impact-fund-badge.svg"
          unoptimized
        />
      </ImageWrapper>
      <p>
        This impact is part of an overall contribution to an Impact Fund.
        Ecologi combines all contributions to a fund and distributes them across
        a range of projects.{" "}
        <Link
          href="/articles/blog/ecologi-impact-funds-a-new-way-for-businesses-to-support-climate-action"
          target="_blank"
        >
          Learn more
        </Link>
        .
      </p>
    </Card>
  );
};
